import React from 'react'

import './Footer.css'

const Footer = () => 
<div className="footer-input">
   <span className="reg-logo" role="img" aria-label="register">®️</span>
</div>

export default Footer;